import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import { ThemeProvider } from 'styled-components';
import { itemThemeNamespace } from '@atlaskit/item';
import memoizeOne from 'memoize-one';
import createItemTheme from './map-navigation-theme-to-item-theme';

import { rootKey } from './util';

var WithRootTheme = function (_PureComponent) {
  _inherits(WithRootTheme, _PureComponent);

  function WithRootTheme() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WithRootTheme);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithRootTheme.__proto__ || _Object$getPrototypeOf(WithRootTheme)).call.apply(_ref, [this].concat(args))), _this), _this.getWithOuterTheme = memoizeOne(function (provided, isCollapsed) {
      return function () {
        var _extends2;

        var outerTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var theme = {
          isCollapsed: isCollapsed || false,
          provided: provided
        };

        return _extends({}, outerTheme, (_extends2 = {}, _defineProperty(_extends2, rootKey, theme), _defineProperty(_extends2, itemThemeNamespace, createItemTheme(provided)), _extends2));
      };
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We want to memoize the 'withOuterTheme' function based on the props that can affect it.
  // This achieves 2 things:
  // 1. A consistent function reference is passed to the ThemeProvider, which avoids it broadcasting
  //    updates to all components using the withTheme HOC
  // 2. The function reference will change if new 'provided' or 'isCollapsed' props are provided,
  //    which will force ThemeProvider to broadcast the update


  _createClass(WithRootTheme, [{
    key: 'render',
    value: function render() {
      var withOuterTheme = this.getWithOuterTheme(this.props.provided, this.props.isCollapsed);
      return React.createElement(
        ThemeProvider,
        { theme: withOuterTheme },
        this.props.children
      );
    }
  }]);

  return WithRootTheme;
}(PureComponent);

WithRootTheme.defaultProps = {
  isCollapsed: false
};
export default WithRootTheme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/theme/with-root-theme.js
// module id = 579
// module chunks = 0